/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import { buildHttpPost } from "./utils/backendInterface.js";
import { isDev } from "./utils/helper.js";


const Activate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let count = 0;
    let _isDev = isDev();

    useEffect(() => {
        count = count + 1;
        console.log("On page load: " + count);
        if (count === 1 && _isDev) {
            return;
        }

        console.log("On page load");
        let user = new URLSearchParams(location.search).get('user');
        let token = new URLSearchParams(location.search).get('token');
        let requestParams = new Map();
        requestParams.set("user", user);
        requestParams.set("token", token);

        function alertContents(httpRequest) {
            if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
                console.log("httpRequest.status: " + httpRequest.status);
                if (httpRequest.status === 200) {
                    console.log('Activation success');

                    sessionStorage.setItem("activationSuccess", "true");

                    navigate('/sign-in');
                } else {
                    console.log('Activation failed');
                    sessionStorage.setItem("activationSuccess", "false");
                    alert("Status: " + httpRequest.statusText);
                    alert("Error: " + httpRequest.responseText);
                }
            }
        }

        let httpRequest = buildHttpPost("activate", requestParams, alertContents);
        httpRequest.sendRequest();
    }, [count]);

    return (
        <>
            <div className="logo-image-container">
                <img src="/logo-small.png" alt="React Logo" />
            </div>
            <h3>Account is being activated</h3>
        </>
    );
}

export default Activate;
